import { DispatchObject } from 'shared/utils/dispatch-object';

export enum SaleAction {
  ClearState = 'CLEAR_STATE',
  CreditSaleSelected = 'SET_CREDIT_SALE_SELECTED',
  SearchTypes = 'SET_SEARCH_TYPES',
}

export type SaleDispatchObject<T> = DispatchObject<SaleAction, T>;
